/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * default covers code defaults, the global default scope and inherited legacy values
 * @export
 */
export const ConfigurationLayer = {
    Default: 'default',
    Organization: 'organization',
    Facility: 'facility',
} as const;
export type ConfigurationLayer = typeof ConfigurationLayer[keyof typeof ConfigurationLayer];


export function instanceOfConfigurationLayer(value: any): boolean {
    for (const key in ConfigurationLayer) {
        if (Object.prototype.hasOwnProperty.call(ConfigurationLayer, key)) {
            if (ConfigurationLayer[key as keyof typeof ConfigurationLayer] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ConfigurationLayerFromJSON(json: any): ConfigurationLayer {
    return ConfigurationLayerFromJSONTyped(json, false);
}

export function ConfigurationLayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationLayer {
    return json as ConfigurationLayer;
}

export function ConfigurationLayerToJSON(value?: ConfigurationLayer | null): any {
    return value as any;
}

export function ConfigurationLayerToJSONTyped(value: any, ignoreDiscriminator: boolean): ConfigurationLayer {
    return value as ConfigurationLayer;
}

